import { createReducer } from 'typesafe-actions';
import { get } from '../../../common/utils/objectUtils';
import { ProductsWishlistActionType, actions } from './actions';
import {
    ProductsWishlistQueueState,
    ProductsWishlistQueueActionTypes,
    PRODUCTS_WISHLIST_QUEUE_UPDATED,
    ProductsWishlistState,
} from './types';

export const productsWishlistQueueReducer = (
    state: ProductsWishlistQueueState = {
        todo: null,
        simpleSku: null,
    },
    action: ProductsWishlistQueueActionTypes
): ProductsWishlistQueueState => {
    if (action.type === PRODUCTS_WISHLIST_QUEUE_UPDATED) {
        return {
            ...state,
            todo: action.payload.todo,
            simpleSku: action.payload.simpleSku,
        };
    }
    return state;
};

export const defaultState = {
    isFetching: false,
    isFetched: false,
    didInvalidate: false,
    products: [],
    count: 0,
};

export const productsWishlistReducer = createReducer<ProductsWishlistState, ProductsWishlistActionType>(defaultState)
    .handleAction(actions.isFetchingProductsWishlistAction, state => ({
        ...state,
        isFetching: true,
    }))
    .handleAction(actions.fetchProductsWishlistSuccessAction, (state, action) => {
        const wishListProducts = get(action.payload.response, 'data.products', []);
        return {
            ...state,
            isFetching: false,
            isFetched: true,
            products: wishListProducts,
            count: wishListProducts.length,
            didInvalidate: false,
        };
    })
    .handleAction(actions.fetchProductsWishlistFailedAction, (state, action) => ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.payload,
    }))
    .handleAction(actions.addToProductsWishlistFailedAction, (state, action) => {
        const productState = [...state.products.filter(productSku => productSku !== action.payload.simpleSku)];
        return {
            ...state,
            isFetching: false,
            products: productState,
            count: productState.length,
        };
    })
    .handleAction(actions.isRemovingFromProductsWishlistAction, (state, action) => {
        const productState = [...state.products.filter(productSku => productSku !== action.payload.simpleSku)];
        return {
            ...state,
            isFetching: true,
            products: productState,
            count: productState.length,
        };
    })
    .handleAction(actions.removeFromProductsWishlistSuccessAction, state => ({
        ...state,
        isFetching: false,
        didInvalidate: false,
    }))
    .handleAction(actions.removeFromProductsWishlistFailedAction, (state, action) => {
        const productState = [action.payload.simpleSku, ...state.products];
        return {
            ...state,
            isFetching: false,
            products: productState,
            count: productState.length,
        };
    })
    .handleAction(actions.isAddingToProductsWishlistAction, (state, action) => {
        const productState = [action.payload.simpleSku, ...state.products];
        return {
            ...state,
            isFetching: true,
            products: productState,
            count: productState.length,
        };
    })
    .handleAction(actions.addToProductsWishlistSuccessAction, state => ({
        ...state,
        isFetching: false,
        didInvalidate: false,
    }))
    .handleAction(actions.clearWishlistAction, () => ({
        ...defaultState,
    }));

export default productsWishlistReducer;
